import React from 'react';
import { cnMessageBox } from '../MessageBox';
import './MessageBox-Tail.css';
export var MessageBoxTail = function (_a) {
    var innerRef = _a.innerRef, tailType = _a.tailType;
    return (React.createElement("div", { ref: innerRef, className: cnMessageBox('Tail') }, tailType === 'default' ? (React.createElement("svg", { viewBox: "0 0 20 20" },
        React.createElement("path", { fill: "currentColor", d: "M20 20H0c5 0 7.949-3.872 10-9 2.051 5.128 5 9 10 9z" }))) : (React.createElement("svg", { viewBox: "0 0 24 24" },
        React.createElement("path", { fill: "currentColor", d: "M12 16c3 0 6 8 12 8H0c6 0 9-8 12-8z" })))));
};
